import React from "react";

const Header = ({ user, onLogout }) => {
  return (
    <header className="mt-header">
      {/* <div className="mt-header-title">FX Bazzar</div> */}
      {user && (
        <div className="mt-header-user">
          <span className="user-info">{user.login}</span>
          {onLogout && (
            <button className="logout-btn" onClick={onLogout}>
              Logout
            </button>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
